import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Switch,
    Typography,
    Divider,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    FormControlLabel,
    IconButton,
    Box
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { DownloadIcon } from '../../../assets/svgIcons/Svg';
import { color } from 'framer-motion';

const CLSettings = ({ open, onClose, openCommentImportModal, importType = "comments" }) => {
    const [fastDelete, setFastDelete] = useState(true);

    const handleToggleFastDelete = () => {
        setFastDelete(prev => !prev);
    };

    const Android12Switch = styled(Switch)(({ theme }) => ({
        padding: 8,
        '& .MuiSwitch-track': {
            borderRadius: 22 / 2,
            '&::before, &::after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                width: 16,
                height: 16,
            },
        },
        '& .MuiSwitch-thumb': {
            boxShadow: 'none',
            width: 16,
            height: 16,
            margin: 2,
        },
        // ✅ set custom checked color
        '& .Mui-checked': {
            color: '#239D80',
        },
        '& .Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#239D80',
        },
    }));

    const isLists = importType === "lists";

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle> <Typography className='ic_title'>
                {isLists ? "Global List Options" : "Comment Library Options"}
            </Typography></DialogTitle>
            <Divider />
            <DialogContent>
                {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography className='ic_body'>Delete comments without confirmation (fast delete)</Typography>
                    <Android12Switch
                        checked={fastDelete}
                        onChange={handleToggleFastDelete}
                    />
                </Box> */}
                {/* <Divider /> */}
                <List>
                    <ListItem sx={{ cursor: "pointer" }} button onClick={openCommentImportModal}>
                        <ListItemText primary={<Typography className='ic_body'>{isLists ? "Import lists" : "Import comments"}</Typography>} />
                        <IconButton edge="end">
                            <ChevronRightIcon />
                        </IconButton>
                    </ListItem>
                    {/* <Divider /> */}
                    {/* <ListItem button>
                        <ListItemText primary={<Typography className='ic_body'>Clean up comment library</Typography>} />
                        <IconButton edge="end">
                            <ChevronRightIcon />
                        </IconButton>
                    </ListItem> */}
                </List>

                {/* <Box mt={3}>
                    <Button
                        variant="outlined"
                        startIcon={<DownloadIcon />}
                        fullWidth
                        className='svg_import'
                    >
                        Download {isLists ? "global list" : "comment library"} as CSV
                    </Button>
                </Box> */}
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={onClose} sx={{ border: "0px !important" }} className='ic-cancle-button'>
                    Close
                </Button>
                <Button onClick={onClose} className="default-btn teams-detail-btn">
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CLSettings;